import React from 'react';

const STATE_VARIANTS: Record<string, string> = {
  completed: 'state-completed',
  complete: 'state-completed',
  received: 'state-received',
  created: 'state-created',
  'in progress': 'state-in-progress',
  in_progress: 'state-in-progress',
  'not started': 'state-not-started',
  pending: 'state-not-started',
  cancelled: 'state-cancelled',
  canceled: 'state-cancelled',
  approved: 'state-completed',
};

export function resolveVariant(state: string): string {
  return STATE_VARIANTS[state.toLowerCase().trim()] ?? 'state-default';
}

interface StateBadgeProps {
  state: string;
}

export const StateBadge: React.FC<StateBadgeProps> = ({ state }) => (
  <span className={`state-badge ${resolveVariant(state)}`}>
    {state.toLowerCase()}
  </span>
);
